// frontend/src/PayPalCancel.js
/**
 * PayPal Cancel Page
 * Shown when user cancels PayPal payment
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';

const PayPalCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body text-center p-5">
              <i className="bi bi-x-circle text-warning" style={{ fontSize: '4rem' }}></i>
              <h3 className="mt-3">Payment Cancelled</h3>
              <p className="text-muted">
                You cancelled the PayPal payment. No charges were made.
              </p>
              <div className="mt-4">
                <button
                  className="btn btn-primary me-2"
                  onClick={() => navigate('/give-gift')}
                >
                  Try Again
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => navigate('/')}
                >
                  Return Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayPalCancel;
